import { render } from "./oap-stories-slide-controls.vue?vue&type=template&id=973d2bec"
import script from "./oap-stories-slide-controls.vue?vue&type=script&lang=js"
export * from "./oap-stories-slide-controls.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__